import {
  Component,
  OnInit,
  Inject,
  ElementRef,
  AfterViewInit,
  Input,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter
} from '@angular/core';

import {defaultsDeep} from 'lodash';
import {PivotTableRenderers} from './pivot-table.renderers';
import {SpiUtils} from '../../services/spi.utils';
import {SpiEchartsUtils} from '../../services/spi.echarts.utils';

declare let $: any;
import { extend } from 'jquery';

@Component({
  selector: 'app-pivot-table',
  templateUrl: './pivot-table.component.html',
  styleUrls: ['./pivot-table.component.scss']
})
export class PivotTableComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() id: string;
  @Input() useUI: boolean;
  @Input() config: any;
  @Input() data: any;
  @Output() newConfig = new EventEmitter<any>();

  private el: ElementRef;
  private container: any;
  private inst: any;
  private targetElement: any;
  private renderers: any;
  private derivers: any;
  private defaultConfig: any;
  private pivotConfig: any;

  constructor(private spiEchartsUtils: SpiEchartsUtils, private spiUtils: SpiUtils,
              private pivotTableRenderers: PivotTableRenderers, @Inject(ElementRef) el: ElementRef) {
    this.el = el;
    $.pivotUtilities.renderers = extend($.pivotUtilities.renderers, {
      'scatter': this.pivotTableRenderers.echartsRendererFromDatasource('scatter', {}, this.pivotTableRenderers),
      'effectScatter': this.pivotTableRenderers.echartsRendererFromDatasource('effectScatter', {}, this.pivotTableRenderers),
      'pie': this.pivotTableRenderers.echartsRendererFromDatasource('pie', {}, this.pivotTableRenderers),
      'funnel': this.pivotTableRenderers.echartsRendererFromDatasource('funnel', {}, this.pivotTableRenderers),
      'multi-pie': this.pivotTableRenderers.echartsRendererFromDatasource('multi-pie', {}, this.pivotTableRenderers),
      'bar': this.pivotTableRenderers.echartsRendererFromDatasource('bar', {}, this.pivotTableRenderers),
      'stack-bar': this.pivotTableRenderers.echartsRendererFromDatasource('stack-bar', {}, this.pivotTableRenderers),
      'line': this.pivotTableRenderers.echartsRendererFromDatasource('line', {}, this.pivotTableRenderers),
      'area': this.pivotTableRenderers.echartsRendererFromDatasource('area', {}, this.pivotTableRenderers),
      'stack-hbar': this.pivotTableRenderers.echartsRendererFromDatasource('stack-hbar', {}, this.pivotTableRenderers),
      'hbar': this.pivotTableRenderers.echartsRendererFromDatasource('hbar', {}, this.pivotTableRenderers),

      'heatmap': this.pivotTableRenderers.echartsRenderer('heatmap', {}, this.pivotTableRenderers),
      'geo': this.pivotTableRenderers.echartsGeoMapRenderer('map', {}, this.pivotTableRenderers),
      'leaflet': this.pivotTableRenderers.echartsRenderer('leaflet', {}, this.pivotTableRenderers)
    });

  }

  ngOnInit(): void {
    setTimeout(() => {
      if (typeof this.data === 'string') {
        this.data = JSON.parse(this.data);
      }
      if (!this.el || !this.el.nativeElement || !this.el.nativeElement.children) {
        console.log('cant build without element');
        return;
      }
      this.container = this.el.nativeElement;
      this.inst = $(this.container);
      this.targetElement = this.inst.find('.pivot-wrapper');
      if (!this.targetElement) {
        console.log('cant find the pivot element');
        return;
      }

      while (this.targetElement.firstChild) {
        this.targetElement.removeChild(this.targetElement.firstChild);
      }

      this.renderers = $.pivotUtilities.renderers;
      this.derivers = $.pivotUtilities.derivers;

      this.defaultConfig = {
        renderers: this.renderers,
        rows: [],
        cols: [],
        rendererName: '',
        onRefresh: (dataPivot) => {
          this.onPivotRefresh(dataPivot);
        },
        filter: (row, filtersData) => {
          let resFilter = true;
          if(filtersData) {
            Object.keys(filtersData).forEach(key => {
              if(filtersData[key] && row[key] && filtersData[key].length > 0 && filtersData[key].indexOf(row[key]) === -1){
                resFilter = false;
              }
            });
          }
          return  resFilter ;
        }
      };
      this.draw();

    }, 800);
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.draw();
    }

    if (typeof this.config === 'string') {
      this.config = JSON.parse(this.config);
    }

    if (changes['config'] && this.config !== undefined && this.config !== null) {
      this.config.onRefresh = (data) => this.onPivotRefresh(data);
      this.draw();
    }
  }

  /**
   * Private Methods
   */

  /**
   * Method to draw the pivot table with provided data and configuration
   */
  private draw(): void {
    if (this.targetElement) {
      this.pivotConfig = defaultsDeep(this.config, this.defaultConfig);
      if (!this.data) {
        this.data = [];
      }
      if (this.useUI) {
        this.targetElement.pivotUI(this.data, this.pivotConfig, true, 'es', this.id);
      } else {
        this.targetElement.pivot(this.data, this.pivotConfig, {});
      }
    }
  }

  /**
   * Method for capturing pivot data configuration changes and emit them to the parent component
   */
  private onPivotRefresh(dataPivot): void {
    this.newConfig.emit(dataPivot);
  }
}
